import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import {ScrollService} from '../../../services/scroll.service';

@Component({
  selector: 'app-card-slider-button',
  templateUrl: './card-slider-button.component.html',
  styleUrls: ['./card-slider-button.component.css']
})
export class CardSliderButtonComponent implements OnInit {

  constructor(private scrollService: ScrollService) { }

  @Input() imageDescription
  @Output() sendMessageEV = new EventEmitter()
  currentCard = 1;
  
  ngOnInit() {
    if (typeof this.imageDescription === 'string') {
      this.imageDescription = JSON.parse(this.imageDescription);
    }
    this.imageDescription.forEach((card,index) => {
      card.hasOwnProperty("description") ? 
        ( card.description.length >= 50 || card.hasOwnProperty('features') ? 
            this.imageDescription[index]["readMoreButton"] = true 
              : this.imageDescription[index]["readMoreButton"] = false 
        )
        :null
    });
  }
  scroll(target: HTMLElement, direction) {
    // const increment = target.scrollLeft + target.offsetWidth / 2;
    if (direction === 'right') {
      if (this.currentCard !== this.imageDescription.length) {
        this.currentCard += 1;
      }
    } else {
      if (this.currentCard !== 1) {
        this.currentCard -= 1;
      }
    }
    this.scrollService.scroll(target, direction, 200);
  }

  sendMessage(value){
    this.sendMessageEV.emit(value)
  }

}
